import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import Diversity2RoundedIcon from "@mui/icons-material/Diversity2Rounded";
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';

const sidebarConfig = [
  // {
  //   title: 'Dashboard',
  //   path: '/dashboard',
  //   icon: <DashboardIcon/>
  // },
  {
    title: "Home",
    path: "/home",
    icon: <HomeRoundedIcon />,
  },
  // {
  //   title: "Contact",
  //   path: "/contactus",
  //   icon: <ContactsIcon />,
  // },
  {
    title: "Project",
    path: "/projects",
    icon: <FolderRoundedIcon />,
  },
  {
    title: "Team",
    path: "/teams",
    icon: <PeopleRoundedIcon />,
  },
  // {
  //   title: 'Peoples',
  //   path: '/peoples',
  //   icon: <GroupsIcon />
  // },
  // {
  //   title: "Subscribers",
  //   path: "/subscribers",
  //   icon: <PersonAddAltRoundedIcon />,
  // },
  {
    title: "Admins",
    path: "/admins",
    icon: <AdminPanelSettingsIcon />,
  },
  // {
  //   title: 'Emails',
  //   path: '/emails',
  //   icon: <EmailIcon/>
  // },
];

export default sidebarConfig;
